<div class="transport-weighings">
  <div class="transport-weighings-layout">
    <div class="table-container">
      <sc-tmc-table [tableModel]="tableModel" [hideFilter]="true" #tmcTableComponent></sc-tmc-table>
    </div>
    <div class="print-button-bar">
      <sc-button (click)="createPrintout()" iconClass="fa-print" dictionaryKey="tmc-yard.ui.transport.details.dialog.weighings.action.createPrintout"></sc-button>
    </div>
  </div>
</div>
